export default __webpack_public_path__ + "static/media/02.492cb064.jpg";